






















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import POILocationForm from '@superUI/Forms/POILocationForm.vue'
import AddPOILocationTrigger from './AddPOILocationTrigger.coffee'

settings =
  name: 'AddPOILocationTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, POILocationForm }
    mixins: [AddPOILocationTrigger.trigger()]

    computed:
      canNotAdd: ->
        { address, city, state, country, zip } = @modal.data
        notFilled = [address, city, state, country, zip].filter((item) -> !item?.length).length
        notFilled > 0

    methods:
      modalData: ->
        address: ''
        city: ''
        state: ''
        country: ''
        zip: ''
        data: {}

export default VueOptions.vue settings
